<template>
  <div>
    <div class="row head">
      <div class="col col-100">Tegoed</div>
    </div>
    <div class="row row-first row-single setting">
      <div v-if="$root.app.platform == 'android'" class="col col-100">
        <span class="row__title">Huidige tegoed</span><br/>
        &euro; {{ data.credit }}
      </div>
      <div v-if="$root.app.platform == 'ios'" class="col col-50">
        <span class="row__title">Huidige tegoed</span>
      </div>
      <div v-if="$root.app.platform == 'ios'" class="col col-50">
        <span class="row__subtitle">&euro; {{ (roundedCosts).toLocaleString() }} ({{ roundedMinutesData }} min*)</span>
      </div>
    </div>
    <div class="row explanation">
                <div class="col col-100">
                    * Elke belminuut of startminuut kost &euro; 0,06 afhankelijk van hoeveelheid gesprekken en de lengte van de gesprekken kan dit enigszins afwijken.
                </div>
            </div>

    <div class="row spacer">&nbsp;</div>

    <div class="row head">
      <div class="col col-100">Beltegoed ophogen</div>
    </div>


    <div class="rows">

      <a :href="data.topUpCreditUrl" target="_blank" @click="backToDashboardClick()">
      <div class="row row-single setting subscription">
                    <div class="avatar avatar--prepaid-minutes"></div>
                    <div class="account-info">
                        <div class="table">
                            <div class="cell">
                                <div class="account-info__title">Belminuten aanschaffen</div>
                                <div class="account-info__subtitle">
                                    <p>Je hebt de keuze uit 100/200/300/400 min</p>
                                    <p>Betalen kan via iDeal / betaallink</p>
                                    <p class="account-info__subtitle--large">vanaf &euro; 4,99 incl btw</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </a>

    </div>

    <div v-if="this.subscription.renewal == true">

      <div class="row head">
        <div class="col col-100">Bundel verlengen</div>
      </div>

      <div class="rows">

        <a :href="data.extendUrl" target="_blank" @click="backToDashboardClick()">
        <div class="row row-single setting subscription">
                    <div class="avatar avatar--prepaid-subscription"></div>
                    <div class="account-info">
                        <div class="table">
                            <div class="cell">
                                <div class="account-info__title">Maandbundel verlengen</div>
                                <div class="account-info__subtitle">
                                    <p>Om de app te gebruiken heb je een maandbundel nodig</p>
                                    <p>Betalen kan via iDeal / betaallink</p>
                                    <p class="account-info__subtitle--large">jouw bundel verloopt op {{ this.subscription.initialExpireTime }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </a>
      </div>

    </div>
  </div>
</template>


<script>
import {required, minLength, maxLength, numeric, email, alphaNum} from 'vuelidate/lib/validators'
import Modal from "./Modal.vue";

export default {
  name: 'Credit',
  components: {
    Modal,
  },
  data() {

    return {
      data: [],
      upgradeCredit: [],
      banks: [],
      requestSend: false,
      prepaidCredit: 0,
      selectedBank: 0,
      isModalVisible: false,
      paymentType: 0,
      emailAddress: null,
      roundedMinutes: 0,
      roundedCosts: 0,
      roundedMinutesData: 0,
      roundedMinutesSource: 0
    }
  },

  mounted() {

       this.$api.get('/credit')
      .then(response => {
        this.data = response.data;
        this.upgradeCredit = response.data.upgradeCredit;
        this.banks = response.data.bank;
        this.emailAddress = response.data.email;
        this.roundedCosts = Math.round(response.data.credit * 100) / 100; 
        this.roundedMinutesSource = response.data.credit / 0.05;
        this.roundedMinutesData = Math.round(this.roundedMinutesSource);
      })
      .catch(e => {

      })
      this.$api.get('/dashboard')
        .then(response => {
            this.data = response.data;
            this.subscription = response.data.subscription;
            root.loading = false;
        })
      .catch(e => {

      })
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    myButtonEventHandler(subscription) {
      this.prepaidCredit = subscription;
    },
    backToDashboardClick() {
      this.$router.push({path: '/app'});
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Credit.vue